import { useDeleteGodown } from "http-hooks/godown/useGodown";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteGodown({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteGodown();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Godown"
      description="Are you sure you want to delete this godown? This godown will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}

